import type { CustomIconProps } from '../types';

const MagnifyingGlassZoomIn = ({ width, height }: CustomIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '12'}
        height={height ?? '12'}
        viewBox="0 0 12 12"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.91429 4.93714C8.91429 7.13366 7.13366 8.91429 4.93714 8.91429C2.74063 8.91429 0.96 7.13366 0.96 4.93714C0.96 2.74063 2.74063 0.96 4.93714 0.96C7.13366 0.96 8.91429 2.74063 8.91429 4.93714ZM8.07238 8.7512C7.21972 9.45292 6.12764 9.87429 4.93714 9.87429C2.21043 9.87429 0 7.66385 0 4.93714C0 2.21043 2.21043 0 4.93714 0C7.66385 0 9.87429 2.21043 9.87429 4.93714C9.87429 6.12764 9.45292 7.21972 8.7512 8.07238L11.8594 11.1806C12.0468 11.368 12.0468 11.6719 11.8594 11.8594C11.6719 12.0468 11.368 12.0468 11.1806 11.8594L8.07238 8.7512ZM2.4 4.8C2.4 4.5349 2.6149 4.32 2.88 4.32H4.32V2.88C4.32 2.6149 4.5349 2.4 4.8 2.4C5.0651 2.4 5.28 2.6149 5.28 2.88V4.32H6.72C6.9851 4.32 7.2 4.5349 7.2 4.8C7.2 5.0651 6.9851 5.28 6.72 5.28H5.28V6.72C5.28 6.9851 5.0651 7.2 4.8 7.2C4.5349 7.2 4.32 6.9851 4.32 6.72V5.28H2.88C2.6149 5.28 2.4 5.0651 2.4 4.8Z"
            fill="#414042"
        />
    </svg>
);

export default MagnifyingGlassZoomIn;
